export enum FunnelTagsTypeEnum {
  PeopleMatched = 'PEOPLE_MATCHED',
  Liked = 'LIKED',
  Contacted = 'CONTACTED',
  Replied = 'REPLIED',
}
